import React from 'react';
import { FaqModal } from './FaqModal';

const LEARN_MORE_URL = 'https://help.sound.xyz/hc/en-us/articles/13099028261659';
const FAQ = {
  'Why does the price per edition change?': (
    <>
      The price increases as editions are collected and decreases as editions are sold based on a
      predefined and immutable pricing curve.
    </>
  ),
  'Why is the actual price different than what I see on the page?': (
    <>
      The price shown includes a small buffer to prevent failed transactions from multiple
      concurrent transactions. Actual collect price may be lower and actual sale price may be
      higher.
    </>
  ),
  'Why is the collect and sell price different?': (
    <>
      The current collect price is higher than the sell price due to fees paid to the artist and
      Sound.
    </>
  ),
  'What is the breakdown of fees?': (
    <>
      For each edition minted during Sound Swap, 7.5% goes to the artist, 2.5% goes to Sound, and
      the remaining 90% is stored in the liquidity pool.
    </>
  ),
  'What happens when I sell an edition?': (
    <>
      When you sell an edition, you're “burning” your NFT and withdrawing from the liquidity pool at
      the current market price.
    </>
  ),
};

export function SamFaq() {
  return <FaqModal faq={FAQ} title="How Sound Swap works" learnMoreUrl={LEARN_MORE_URL} />;
}
